<!--
// app/components/pages/region-circulars/CircularElement.vue
-->
<script setup lang="ts">
import type { Circular } from "~~/src/content/domain/models/Circular";

type Props = {
  circular: Circular;
  lang: string;
};
defineProps<Props>();

const { $t } = useI18n();
</script>

<template>
  <div class="p-4 mb-3">
    <p class="text-gray-400 text-sm uppercase mb-3">
      {{ circular.acf.pretitle }},
      {{ new Date(circular.date).toLocaleDateString(lang, { dateStyle: "long" }) }}
    </p>

    <h2 :class="['text-xl md:text-2xl font-bold', { 'mb-5': !circular.acf.description }]">
      {{ circular.title.rendered }}
    </h2>

    <p v-if="circular.acf.description" class="mb-5" v-html="circular.acf.description"></p>
    <a :href="circular.acf.pdf_url" target="_blank" class="btn btn-primary text-sm">{{
      $t("circulars.page.button.download")
    }}</a>
  </div>
  <hr />
</template>

<style scoped></style>
